<template>
<div class="c-not-found px-4 pt-14 pb-12">
  <c-logo/>
  <div class="h-25"/>
  <h1 class="text-5xl leading-none font-extrabold tracking-tight text-basic-high text-center">
    {{ translations['404-title'] }}
  </h1>
  <div class="pt-2 text-lg leading-7 font-normal text-center">{{ translations['404-text'] }}</div>
  <div class="h-12"/>
  <template v-if="recommend && recommend > 0">
    <div class="pb-4 text-sm leading-5 font-semibold tracking-wide uppercase">{{ translations['404-popular'] }}</div>
    <c-list
      :border="true"
      :item-attrs="{ iconTrailing: 'chevron-right', hoverNone: true }"
      :list="recommend"
      class="border-y"
      color="primary"
      size="large"
    />
    <div class="h-8"/>
  </template>
  <a href="/" class="font-subtitle1">{{ translations['404-main'] }}</a>
</div>
</template>

<script>
import CList from '@/components/CList'
import CLogo from '@/components/CLogo'
import { computed } from 'vue'
import { useStore } from 'vuex'
import Translation from 'dcode/classes/Translation'

export default {
  name: 'CNotFound',
  components: {
    CList,
    CLogo
  },
  setup () {
    const store = useStore()
    /**
     * @type {Object.<string, string>}
     */
    const translations = Translation.getByList([
      '404-main',
      '404-popular',
      '404-text',
      '404-title'
    ])

    return {
      recommend: computed(() => store.getters.get404),
      translations
    }
  }
}
</script>

<style lang="scss">
.c-not-found {
  max-width: calc(576px + 32px);
  margin: 0 auto;

  .h-25 {
    height: 100px;
  }
}
</style>
